import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { LOGO_URL, CONTACT } from "../lib/assets";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] text-white pt-24 md:pt-32 pb-10"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          <div className="md:col-span-4">
            <img
              src={LOGO_URL}
              alt="Trust Flooring & Interiors"
              className="h-16 w-auto"
            />
            <p className="mt-8 text-[#A0A0A0] text-sm leading-relaxed max-w-xs">
              A single interior trade partner for builders and developers across
              Auckland, Christchurch and Queenstown.
            </p>
            <div className="flex gap-3 mt-8">
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="w-9 h-9 flex items-center justify-center border border-[#2a2a2a] hover:border-[#EB1D25] hover:text-[#EB1D25] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={14} strokeWidth={1.5} />
              </a>
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-9 h-9 flex items-center justify-center border border-[#2a2a2a] hover:border-[#EB1D25] hover:text-[#EB1D25] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={14} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading uppercase tracking-[0.25em] text-[10px] text-white/60 mb-6">
              Navigate
            </h4>
            <ul className="space-y-3 text-[#A0A0A0] text-sm">
              <li>
                <Link to="/" className="hover:text-[#EB1D25] transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#EB1D25] transition-colors" data-testid="footer-link-about">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[#EB1D25] transition-colors" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-[#EB1D25] transition-colors" data-testid="footer-link-projects">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#EB1D25] transition-colors" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading uppercase tracking-[0.25em] text-[10px] text-white/60 mb-6">
              Locations
            </h4>
            <ul className="space-y-5 text-[#A0A0A0] text-sm">
              <li>
                <p className="text-white text-sm font-heading">Auckland</p>
                <p className="mt-1">{CONTACT.aucklandAddress}</p>
              </li>
              <li>
                <p className="text-white text-sm font-heading">Christchurch</p>
                <p className="mt-1">{CONTACT.christchurchAddress}</p>
              </li>
              <li>
                <p className="text-white text-sm font-heading">Queenstown</p>
                <p className="mt-1">{CONTACT.queenstownAddress}</p>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading uppercase tracking-[0.25em] text-[10px] text-white/60 mb-6">
              Contact
            </h4>
            <ul className="space-y-3 text-[#A0A0A0] text-sm">
              <li>
                <a
                  href={`mailto:${CONTACT.emailPrimary}`}
                  className="hover:text-[#EB1D25] transition-colors break-all"
                  data-testid="footer-email"
                >
                  {CONTACT.emailPrimary}
                </a>
              </li>
              <li>
                <a
                  href={`tel:+64${CONTACT.phoneMartin.replace(/\s/g, "").replace(/^0/, "")}`}
                  className="block hover:text-[#EB1D25] transition-colors"
                  data-testid="footer-phone-martin"
                >
                  Martin · {CONTACT.phoneMartin}
                </a>
              </li>
              <li>
                <a
                  href={`tel:+64${CONTACT.phoneMiguel.replace(/\s/g, "").replace(/^0/, "")}`}
                  className="block hover:text-[#EB1D25] transition-colors"
                  data-testid="footer-phone-miguel"
                >
                  Miguel · {CONTACT.phoneMiguel}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1f1f1f] mt-20 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-[#A0A0A0]">
          <p>© {year} Trust Flooring & Interiors</p>
          <p className="tracking-[0.2em] uppercase">Auckland · Christchurch · Queenstown</p>
        </div>
      </div>
    </footer>
  );
}
